import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'CuttingRecord',
    column_type: 'id',
    label_key_path: 'cuttingRecord.id',
  },
  created_at: {
    model_name: 'CuttingRecord',
    column_type: 'datetime',
    label_key_path: 'cuttingRecord.createdAt',
  },
  updated_at: {
    model_name: 'CuttingRecord',
    column_type: 'datetime',
    label_key_path: 'cuttingRecord.updatedAt',
  },
  order: {
    model_name: 'CuttingRecord',
    column_type: 'belongs_to',
    label_key_path: 'cuttingRecord.order',
    extra: {
      association_name: 'order',
      model_name: 'Order',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  order_id: {
    model_name: 'CuttingRecord',
    column_type: 'belongs_to',
    label_key_path: 'cuttingRecord.order',
    extra: {
      association_name: 'order',
      model_name: 'Order',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  cutting_at: {
    model_name: 'CuttingRecord',
    column_type: 'datetime',
    label_key_path: 'cuttingRecord.cuttingAt',
  },
  cutting_items: {
    model_name: 'CuttingRecord',
    column_type: 'has_many',
    label_key_path: 'cuttingRecord.cuttingItems',
    extra: {
      association_name: 'cutting_items',
      model_name: 'CuttingItem',
      foreign_key: 'cutting_record_id',
      display_column: 'id',
    },
  },
  cutting_item_ids: {
    model_name: 'CuttingRecord',
    column_type: 'has_many',
    label_key_path: 'cuttingRecord.cuttingItems',
    extra: {
      association_name: 'cutting_items',
      model_name: 'CuttingItem',
      foreign_key: 'cutting_record_id',
      display_column: 'id',
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
